import { DigLitSelfAssessmentResult } from "src/app/_models/DigitalLiteracy";
import { AppConstants } from "src/app/constants/constants";
import { DigLitSelfAssessmentState } from "./dig-lit-self-assessment.state";
import { QuestionModes } from "src/app/constants/DigitalLiteracyConstants";

export function setInitialState(state: DigLitSelfAssessmentState, action: {result: DigLitSelfAssessmentResult}): DigLitSelfAssessmentResult {
	
	if(state.data === null)
	{
		let lastStemWithAnswers = 0;
		var mapped = action.result.stems.map( stem => {
			return {... stem, 
				questions: stem.questions.map( q => { 
					var questionType = q.type;
						let lastAnswer = q.answers[q.answers.length - 1];
						return {
							...q, 
							answers: q.answers.map( a => 
								{ 
									let disabled = questionType == QuestionModes.Multiple && lastAnswer.value == AppConstants.TRUE && lastAnswer.id != a.id ? true : false;
									let answerValue = questionType == QuestionModes.Slider ? (a.value == null ? 1 : parseInt(a.value)) : (a.value == null ? false : JSON.parse(a.value));
									lastStemWithAnswers = questionType == QuestionModes.Slider ? 
										( answerValue > 1 ? stem.id : lastStemWithAnswers) : ( answerValue == true ? stem.id : lastStemWithAnswers)

									return {
										...a, 
										description: formatTooltip(a.description, disabled), descriptionCy: formatTooltip(a.descriptionCy, disabled),
										value: answerValue,
										disabled: disabled
									} 
						})};
					})
				};
		});
	
		return {...action.result, stems: mapped, lastStemWithAnswers: lastStemWithAnswers};
	}
	else
		return state.data;
}

export function formatTooltip(value: string, disabled: boolean)
{
	var newValue = value.replace(AppConstants.TOOLTIP, disabled? AppConstants.DIG_LIT_TOOLTIP_ICON_DISABLED : AppConstants.DIG_LIT_TOOLTIP_ICON);
	return newValue;
}

